import React from 'react'
// import PropTypes from 'prop-types'
import { Grid, CardContent, Skeleton } from '@mui/material'
import { Paper } from './style';

const SectionSkeleton = () => {
    return (
        <Paper variant="outlined">
            <CardContent
            >
                <Skeleton width="25%" height={40} />
                <Grid container direction="row" spacing={3}>
                    {Array.from(new Array(5)).map(() => (
                        <Grid item lg={2}>
                            <Skeleton height={80} />
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Paper>
    )
}

SectionSkeleton.propTypes = {

}

export default SectionSkeleton
